module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"month":"måned","annual":"år","2months":"Du sparer 2 måneder","free":"Gratis for alltid"},"en":{"month":"monthly","annual":"year","2months":"You save 2 months","free":"Free forever"}}')
  delete Component.options._Ctor
}
